import { render, staticRenderFns } from "./DicomThumbnail.vue?vue&type=template&id=30148ea6&scoped=true"
import script from "./DicomThumbnail.vue?vue&type=script&lang=js"
export * from "./DicomThumbnail.vue?vue&type=script&lang=js"
import style0 from "./DicomThumbnail.vue?vue&type=style&index=0&id=30148ea6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30148ea6",
  null
  
)

export default component.exports